import { stringsContainsIgnoreCase } from ".";
import { IfmsAppRoutes } from "../config/routes";
import { IfmsRoute } from "../config/types";
import { FormType } from "../fms.enum";

const cleanupRoute = (r: IfmsRoute): RoutePathMetadata => {
  let path = r.path;
  const hasMode = stringsContainsIgnoreCase(path, ':mode');

  const parameterIndex = path.indexOf('/:');
  if (parameterIndex >= 0) {
    return { route: path.substring(0, parameterIndex), hasMode};
  }

  return {route: r.path, hasMode};
};

interface RoutePathMetadata {
  route: string,
  hasMode: boolean,
};

let applicationRoutePaths: RoutePathMetadata[] = [];

function getApplicationRoutePaths(): RoutePathMetadata [] {
  if (applicationRoutePaths.length <= 0) {
    applicationRoutePaths = IfmsAppRoutes.map(cleanupRoute);
  }

  return applicationRoutePaths;
}

/**
 * Returns base URL of the route. For example if complete URL is /oceanImport/mbl/edit/2813/1/bill
 * it returns /oceanImport/mbl/edit. This url base is than used in combination with storage key
 * to generate unique fastStorage key (for example, 'editOiMbl2813-/oceanImport/mbl/edit')
 * This way, both these urls will have the same key generated: 
 *   a) /oceanImport/mbl/edit/2813/1/bill
 *   b) /oceanImport/mbl/edit/2813
 */
 export function getRoutePath(fullUrl: string): string {
  const queryIndex = fullUrl.indexOf('?');

  const fullUrlWithoutQuery = queryIndex >= 0 ? fullUrl.substring(0, queryIndex) : fullUrl;
  const match = getApplicationRoutePaths().find(x => fullUrlWithoutQuery.startsWith(x.route));

  if (!match) {
    return fullUrlWithoutQuery;
  }

  let result = match.route;

  if (match.hasMode) {
    if (stringsContainsIgnoreCase(fullUrlWithoutQuery, `/${FormType.ModeAdd}`)) {
      result = `${result}/${FormType.ModeAdd}`;
    }
    if (stringsContainsIgnoreCase(fullUrlWithoutQuery, `/${FormType.ModeEdit}`)) {
      result = `${result}/${FormType.ModeEdit}`;
    }
    if (stringsContainsIgnoreCase(fullUrlWithoutQuery, `/${FormType.ModeView}`)) {
      result = `${result}/${FormType.ModeView}`;
    }
  }

  return result;
}